<template>
  <div class="container" v-loading="loading">
    <!-- 搜索栏 -->
    <div class="search-bar" v-if="website.roleType === 'factory'">
      <el-button class="add-btn" icon="el-icon-plus" @click="addDialogVisible = true">
        {{ $t('policyAnnouncement.add') }}
      </el-button>
    </div>
    
    <!-- 列表 -->
    <div class="empty_" v-if="!dataSource.length">
      <el-empty :description="$t('policyAnnouncement.noData')"></el-empty>
    </div>
    <div class="list" v-else>
      <div 
        class="list-item"
        v-for="(item, index) in dataSource"
        :key="index"
        @click="toDetail(item.id)"
      >
        <!-- 标题 -->
        <div class="top">
          <div class="title">{{ item.title}}</div>
          <div class="action-btns" v-if="website.roleType === 'factory'">
            <i class="edit el-icon-edit" @click.stop="handleEdit(item)" ></i>
            <i class="delete el-icon-delete" @click.stop="handleDelete(item.id)" ></i>
          </div>
        </div>
        
        <!-- 内容描述 -->
        <div class="content">
          <p class="description">{{ item.content }}</p>
        </div>
        
        <!-- 标签和时间 -->
        <div class="bottom">
          <!-- 标签区域 -->
          <div class="tags" v-if="item.categoryLabel&& item.categoryLabel.length">
            <span 
              class="tag" 
              v-for="(tag, tagIndex) in item.categoryLabel.split(',')" 
              :key="tagIndex"
            >
              #{{ tag }}
            </span>
          </div>
          
          <!-- 时间 -->
          <div class="time">
            {{ item.createTime  }}
          </div>
        </div>
      </div>
    </div>
    
    <!-- 分页 -->
    <div class="pagination_">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listReq.current"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="listReq.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listReq.total">
      </el-pagination>
    </div>
    <el-dialog
      :title="$t('policyAnnouncement.add')"
      :visible.sync="addDialogVisible"
      width="40%"
      center
      :before-close="handleClose"
    >
      <el-form :model="dialogForm"  ref="addFormRef" label-width="80px">
        <el-form-item label="标题：" prop="title" >
          <el-input v-model="dialogForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="内容：" prop="content" >
          <el-input type="textarea" v-model="dialogForm.content" placeholder="请输入内容" :maxlength="1000" show-word-limit autosize></el-input>
        </el-form-item>
        <el-form-item label="标签：" prop="categoryLabel" >
          <div class="tag-container">
            <el-tag v-for="(tag, index) in tags" :key="index" closable @close="handleCloseTag(index)" class="tag-item">{{tag }}</el-tag>
          </div>
          <el-input v-model="inputValue" placeholder="请输入标签(最多三个，按回车确定)" :maxlength="255" @blur="handleconfirm" @keyup.enter.native="handleconfirm"></el-input>
        </el-form-item>
        <el-form-item label="图片：" prop="photo">
          <el-upload
            class="upload-demo"
            action=""
            accept="image/jpg, image/png, image/jpeg"
            :auto-upload="false"
            :on-change="(file, fileList)=> uploadFile(file, fileList, 'photo')"
            :on-preview="handlePictureCardPreview"
            :file-list="Filelist.photo"
            :on-remove="(file, fileList)=> handleRemove(file, fileList, 'photo')"
            :limit="5"
            list-type="picture-card">
            <!-- <el-button size="small" type="primary" v-if="Filelist.photo.length<5">{{$t('policyAnnouncement.uploadClick')}}</el-button> -->
            <i class="el-icon-plus" v-if="Filelist.photo.length<5"></i>
            <div slot="tip" class="el-upload__tip">{{$t('policyAnnouncement.onlyPng')}}</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="文件：" prop="file">
          <el-upload
            class="upload-demo"
            action=""
            accept=""
            :auto-upload="false"
            :before-upload="(file) => beforeUpload(file, 'file')"
            :on-change="(file, fileList)=> uploadFile(file, fileList, 'file')"
            :file-list="Filelist.file"
            :on-remove="(file, fileList)=> handleRemove(file, fileList, 'file')"
            :limit="5"
            list-type="file">
            <el-button size="small" type="primary" v-if="Filelist.file.length<5">{{$t('policyAnnouncement.uploadClick')}}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频：" prop="video">
          <el-upload
            class="video-uploader"
            action=""
            accept="video/mp4, video/avi, video/mov"
            :auto-upload="false"
            :before-upload="(file) => beforeUpload(file, 'video')"
            :on-change="(file, fileList)=> uploadFile(file, fileList, 'video')"
            :show-file-list="false">
            <div v-if="videoUrl" class="video-wrapper">
              <video :src="videoUrl" class="video-preview" controls></video>
              <i class="el-icon-delete video-delete-icon" @click.stop="handleVideoRemove"></i>
            </div>
            <i v-else class="el-icon-plus video-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="接受对象:" prop="roleType">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" >全选</el-checkbox>
          <el-checkbox-group v-model="roleType" @change="handleChange" >
            <el-checkbox v-for="item in roleTypeList" :label="item.value" :key="item.value" >{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" >
        <el-button @click="handleClose" class="cancel-dialog">取消</el-button>
        <el-button type="primary" @click="handleAdd" class="confirm-dialog">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
  </div>
</template>

<script>
import website from "@/config/website";
import { policyAnnouncementPage, deletePolicyAnnouncement, addPolicyAnnouncement, uploadFile, editPolicyAnnouncement } from "@/api/announcement/index";
export default {
  name: 'PolicyAnnouncement',
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      videoUrl: '',
      isIndeterminate: false,
      checkAll: false,
      roleTypeList: [
        {value: 'general', label: '总代'},
        {value: 'shop', label: '店铺'},
        {value: 'area', label: '销售经理'},
        {value: 'maintenance', label: '维保'}
      ],
      roleType: [],
      tags: [],
      isEdit: false,
      inputValue: '',
      loading: false,
      addDialogVisible: false,
      dialogForm: {
        title: '',
        content: '',
        categoryLabel:'' ,
        photo:'',
        video:'',
        file:'',
        roleType:''
      },
      Filelist:{
        photo:[],
        file:[],
        video:[]
      },
      dataSource: [], 
      listReq: {
        current: 1,
        size: 5,
        total: 0
      }
    }
  },
  computed: {
    website() {
      return website;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 上传前验证文件大小
    beforeUpload(file, type) {
      const maxSize = 50 * 1024 * 1024; // 50MB
      const fileSize = file.size;
      
      if (fileSize > maxSize) {
        const typeName = type === 'video' ? '视频' : '文件';
        this.$message.error(`${typeName}大小不能超过 50MB！`);
        return false;
      }
      return true;
    },
    handleCheckAllChange(val) {
      this.roleType = val ? this.roleTypeList.map(item => item.value) : [];
      this.isIndeterminate = false;
    },
    handleChange(value) {
      let checkedCount = value.length;
        this.checkAll = checkedCount === this.roleTypeList.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.roleTypeList.length;
    },
    // 上传文件
    async uploadFile(file, fileList, target) {
      // 验证文件大小（仅对文件和视频进行验证）
      if (target === 'file' || target === 'video') {
        const maxSize = 50 * 1024 * 1024; // 50MB
        const fileSize = file.size;
        
        if (fileSize > maxSize) {
          const typeName = target === 'video' ? '视频' : '文件';
          this.$message.error(`${typeName}大小不能超过 50MB！`);
          fileList.pop(); // 从文件列表中移除
          return;
        }
      }
      
      console.log('file', this.Filelist[target]);
    let FormDatas = new FormData()
    FormDatas.append('file',file.raw);
    let { data } = await uploadFile(FormDatas);
   if(data && data.code === 200) {
    this.$message.success(this.$t('policyAnnouncement.uploadSuccess'));
    let obj = {
      domain: data.data.domain,
      status: "success",
      name: data.data.originalName,
      size: file.size,
      url: data.data.link,
    }
    // 如果是视频，设置 videoUrl 用于预览
    if (target === 'video') {
      this.videoUrl = data.data.link;
      // 同时保存到 Filelist 用于提交
      this.Filelist.video = [obj];
    } else {
      this.Filelist[target].push(obj);
    }
    } else {
      fileList.pop();
      this.$message.error(data.message);
      return
    }
    },
    // 删除文件
    handleRemove(file, fileList, target) {
      let currentIndex;
      this.Filelist[target].map((x,idx) => {
        if(file.uid === x.uid) {
          currentIndex = idx;
        }
      })
      this.Filelist[target].splice(currentIndex, 1);
    },
    // 删除视频
    handleVideoRemove() {
      this.videoUrl = '';
      this.Filelist.video = [];
    },
    // 添加公告
    async handleAdd() {
      console.log(this.roleType);
      this.dialogForm.roleType = this.roleType.join(',');
      this.dialogForm.categoryLabel = this.tags.join(',');
      this.dialogForm.photo = this.Filelist.photo.map(x => x.url).join(',');
      this.dialogForm.file = this.Filelist.file.map(x => x.url).join(',');
      this.dialogForm.video = this.Filelist.video.map(x => x.url).join(',');
      this.dialogForm.fileName = this.Filelist.file.map(x => x.name).join(',');
      console.log(this.dialogForm);
      const res = this.isEdit ? await editPolicyAnnouncement(this.dialogForm) : await addPolicyAnnouncement(this.dialogForm);
      if (res.data && res.data.code === 200) {
        this.$message.success(this.isEdit ? this.$t('policyAnnouncement.editSuccess') : this.$t('policyAnnouncement.addSuccess'));
        this.handleClose();
        this.getList();
      } else {
        this.$message.error(res.data.message);
      }
    },
    // 确认标签
    handleconfirm() {
      let inputValue = this.inputValue;
      if(inputValue){
      if(this.tags.includes(inputValue)) return this.$message.error('标签已存在');
      if(this.tags.length>=3) return this.$message.error('标签最多三个');
      this.tags.push(inputValue);
      }
      this.inputValue = '';
    },
    // 关闭标签
    handleCloseTag(index) {
      this.tags.splice(index, 1);
    },
    // 编辑公告
    handleEdit(item) {
      this.dialogForm= {...item};
      this.Filelist.photo = item.photo ? item.photo.split(',').map(x => ({url: x.trim()})) : [];
      this.Filelist.file = item.file ? item.file.split(/[,\s]+/).filter(x => x.trim()).map((x, index) => {
        const url = x.trim();
        let fileName = '';
        if (item.fileName) {
          const fileNames = item.fileName.split(',').map(n => n.trim()).filter(n => n);
          fileName = fileNames[index] || url.split('/').pop() || 'file';
        } else {
          fileName = url.split('/').pop() || 'file';
        }
        return { url, name: fileName };
      }) : [];
      // 处理视频 - 设置 videoUrl 用于预览
      if (item.video) {
        const videoUrls = item.video.split(',').map(x => x.trim()).filter(x => x);
        if (videoUrls.length > 0) {
          this.videoUrl = videoUrls[0];
          this.Filelist.video = [{ url: videoUrls[0] }];
        } else {
          this.videoUrl = '';
          this.Filelist.video = [];
        }
      } else {
        this.videoUrl = '';
        this.Filelist.video = [];
      }
      this.roleType = item.roleType ? item.roleType.split(',') : [];
      this.tags = item.categoryLabel ? item.categoryLabel.split(',') : [];
      // 更新全选状态
      const checkedCount = this.roleType.length;
      this.checkAll = checkedCount === this.roleTypeList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.roleTypeList.length;
      this.isEdit = true;
      this.addDialogVisible = true;
    },
    // 删除公告
  handleDelete(id) {
      this.$confirm(this.$t('policyAnnouncement.deleteConfirm'), this.$t('policyAnnouncement.deleteConfirmTitle'), {
        confirmButtonText: this.$t('policyAnnouncement.confirm'),
        cancelButtonText: this.$t('policyAnnouncement.cancel'),
        type: 'warning'
      }).then(async () => {
        const res = await deletePolicyAnnouncement(id);
        if (res.data && res.data.code === 200) {
          this.$message.success(this.$t('policyAnnouncement.deleteSuccess'));
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    
    // 查看详情
    toDetail(id) {
      this.$router.push({
        path: '/goods/policyAnnouncement-detail',
        query: { id }
      })
    },
    
    // 分页 - 每页条数改变
    handleSizeChange(val) {
      this.listReq.size = val;
      this.listReq.current = 1;
      this.getList();
    },
    
    // 分页 - 当前页改变
    handleCurrentChange(val) {
      this.listReq.current = val;
      this.getList();
    },
    
    // 获取列表数据
    async getList() {
      try {
        this.loading = true;
        const res = await policyAnnouncementPage({current: this.listReq.current, size: this.listReq.size});
        if (res.data && res.data.code === 200) {
          this.dataSource = res.data.data.records || [];
          this.listReq.total = res.data.data.total || 0;
        }
      } catch (e) {
        console.error('获取数据失败:', e);
      } finally {
        this.loading = false;
      }
    },
    
    // 对话框关闭前的处理
    handleClose() {
      this.dialogForm = {
        title: '',
        content: '',
        categoryLabel: '',
      };
      this.inputValue = '';
      this.tags = [];
      this.roleType = [];
      this.checkAll = false;
      this.isIndeterminate = false;
      this.videoUrl = '';
      this.addDialogVisible = false;
      this.isEdit = false;
      this.Filelist = {
        photo: [],
        file: [],
        video: []
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: #f0f2f5;
  height: 100%;
  overflow: auto;
  padding: 20px;
}

.search-bar {
  display: flex;
  justify-content: flex-start;
  padding: 0 19px;
  align-items: center;
  min-height: 64px;
  background: #FFFFFF;
  box-shadow: 0 2px 8px 0 rgba(30, 85, 255, 0.1);
  border-radius: 4px;
  
  .add-btn {
    background: #50C4CB;
    color: #fff;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    border: none;
    
    &:hover {
      background: #59CFD6;
    }
  }
}

.list {
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(30, 85, 255, 0.1);
  border-radius: 4px;
  margin-top: 10px;
  padding: 13px;
  
  .list-item {
    padding: 20px;
    border-bottom: 1px solid #E5E5E5;
    cursor: pointer;
    transition: background-color 0.3s;
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background-color: #f9f9f9;
    }
    
    .action-btns {
      flex: 1;
      text-align: right;
      .edit {
        color: #50C4CB;
        width: 16px;
        height: 16px;
        margin-right: 20px;
      }
      .delete {
        color: #fa5b5e;
        width: 16px;
        height: 16px;
      }
    }
    
    .top {
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        line-height: 1.5;
        flex: 1;
        text-align: left;
      }
    }
    
    .content {
      margin-bottom: 16px;
      
      .description {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        line-height: 1.8;
        margin: 0;
        word-break: break-word;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    
    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        
        .tag {
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #50C4CB;
          background-color: #F0F9FA;
          padding: 4px 8px;
          border-radius: 4px;
        }
      }
      
      .time {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
      }
    }
  }
}

.cancel-dialog {
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  width: 100px;
  height: 40px;
  color: #606266;
}

.confirm-dialog {
  background: #50C4CB;
  border: 1px solid #50C4CB;
  width: 100px;
  border-radius: 4px;
  color: #fff;
  height: 40px;
}

.empty_ {
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(30, 85, 255, 0.1);
  border-radius: 4px;
  margin-top: 20px;
  padding: 60px 20px;
  text-align: center;
}
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
  width: 100%;
  align-items: flex-start;
}

.tag-item {
  min-width: 60px;
  max-width: 100%;
  min-height: 25px;
  line-height: 1.4;
  text-align: center;
  border-radius: 4px;
  color: #50C4CB;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  padding: 4px 8px;
  box-sizing: border-box;
  flex-shrink: 0;
}

/deep/ .tag-container .el-tag {
  white-space: normal !important;
  height: auto !important;
  line-height: 1.4 !important;
  word-break: break-word !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  margin: 0 !important;
}
.pagination_ {
  text-align: right;
  margin-top: 20px;
  margin-bottom: 20px;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #01AAA7;
}

/deep/ .el-pagination.is-background .btn-next,
/deep/ .el-pagination.is-background .btn-prev {
  background-color: #fff;
}

/deep/ .el-pagination.is-background .el-pager li {
  background-color: #fff;
}

/* 复选框选中时的样式 */
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #50C4CB;
  border-color: #50C4CB;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #50C4CB;
}

/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #50C4CB;
  border-color: #50C4CB;
}

.video-uploader {
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: #409EFF;
  }
  .video-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .video-wrapper {
    position: relative;
    width: 178px;
    height: 178px;
  }
  .video-preview {
    width: 178px;
    height: 178px;
    display: block;
    object-fit: cover;
  }
  .video-delete-icon {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 20px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 5px;
    cursor: pointer;
    border-radius: 0 6px 0 6px;
    z-index: 10;
  }
  .video-delete-icon:hover {
    background-color: rgba(255, 0, 0, 0.7);
  }
}
</style>

